import {Partner} from '../../model/admin/partner';
import {BaseResponse} from '../internal/baseresponse';
export class ADMPartnerDetailResult extends BaseResponse {
  data: Partner;
}



// WEBPACK FOOTER //
// ./src/app/response/admin/admpartnerdetailresult.ts